// extracted by mini-css-extract-plugin
export default {"container":"Table_container__YmQNy","horizontalScrollable":"Table_horizontalScrollable__oWqE7","table":"Table_table__YUzYe"};